const regexp = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;

function isPhone(phone: string): boolean {
  return regexp.test(phone);
}

export default isPhone;
